<template>
	<div id="app">
		<HeaderComponent />
		<div class="main-content">
			<transition name="page-fade" mode="out-in">
				<router-view :key="$route.path" />
			</transition>
		</div>
		<FooterComponent />
	</div>
</template>

<script>
	import HeaderComponent from './components/Header.vue';
	import FooterComponent from './components/Footer.vue';

	export default {
		name: 'App',
		components: {
			HeaderComponent,
			FooterComponent
		}
	};
</script>
